// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createActions } from 'redux-actions';

export const POST_ADD_AAD_USER = 'POST_ADD_AAD_USER';
export const POST_ADD_AAD_USER_SUCCESS = 'POST_ADD_AAD_USER_SUCCESS';

export const POST_ADD_BULK_AAD_USERS = 'POST_ADD_BULK_AAD_USERS';
export const POST_ADD_BULK_AAD_USERS_SUCCESS = 'POST_ADD_BULK_AAD_USERS_SUCCESS';

export const CLEAR_AAD_USER_MESSAGE = 'CLEAR_AAD_USER_MESSAGE';
export const CLEAR_BULK_USERS_MESSAGE = 'CLEAR_BULK_USERS_MESSAGE';

export const {
    postAddAadUser,
    postAddAadUserSuccess,

    postAddBulkAadUsers,
    postAddBulkAadUsersSuccess,

    clearAadUserMessage,
    clearBulkUsersMessage,
} = createActions(
    POST_ADD_AAD_USER,
    POST_ADD_AAD_USER_SUCCESS,

    POST_ADD_BULK_AAD_USERS,
    POST_ADD_BULK_AAD_USERS_SUCCESS,

    CLEAR_AAD_USER_MESSAGE,
    CLEAR_BULK_USERS_MESSAGE
);
